import queryString from 'query-string';
import {USERCENTER_TICKET} from '../../constant/CookieKeys'

function app_casher() {
  let userInfo = window.$bus.user;
  let deviceInfo = window.$bus.device_info;
  const ticket = window.$bus.user.ticket;
  let data = null
  if (userInfo === null || ticket === null) {
    data = {
      userId: null,
      osVersion: deviceInfo.osVersion,
      seqI: '',
      uid: null,
      device: deviceInfo.device,
      appVersion: deviceInfo.appVersion,
      ticket: null,
      channel: deviceInfo.channel,
      mac: deviceInfo.mac,
      iapType: 'VIPOnly',
      osType: deviceInfo.osType,
      pagename: 'ACT_D',
      actid: gact.source,
      clocation: 1,
    };
  } else {
    data = {
      userId: userInfo.uid,
      osVersion: deviceInfo.osVersion,
      seqI: '',
      uid: userInfo.uuid,
      device: deviceInfo.device,
      appVersion: deviceInfo.appVersion,
      ticket: userInfo.ticket,
      channel: deviceInfo.channel,
      mac: deviceInfo.mac,
      iapType: 'VIPOnly',
      osType: deviceInfo.osType,
      pagename: 'ACT_D',
      actid: gact.source,
      clocation: 1,
    }
  }

  if (gact.is_iphone) {
    MgtvApi.getIap({
      videoId: 1,
      iapType: 'VIPOnly',
      url: gact.config.iphone_casher + "?" + queryString.stringify(data)
    });
  } else if (gact.is_android) {
    MgtvApi.getIap({
      videoId: 1,
      iapType: 'VIPOnly',
      url: gact.config.aphone_casher + "?" + queryString.stringify(data)
    });
  } else {
    MgtvApi.getIap({
      videoId: 1,
      iapType: 'VIPOnly',
      url: gact.config.ipad_casher + "?" + queryString.stringify(data)
    });
  }
}

function h5_casher() {
  const source = gact.source;
  const param = {
    clocation: 1,
    source: source,
    ftype: 5,
    product_level: gact.is_ott ? 2 : 1,
  }

  window.localStorage.removeItem(USERCENTER_TICKET); //清除掉用户中心的原有ticket,使用url中的ticket
  window.location.href = gact.config.h5_casher + "?" + queryString.stringify(param);
}

export default function to_casher() {
  console.log('前往收银台')
  setTimeout(() => {
    if (gact.is_app) {
      app_casher()
    } else {
      h5_casher()
    }
  }, 100)
}



// WEBPACK FOOTER //
// ./src/tools/mgtv/casher.js